module.exports = __webpack_public_path__ + "static/tools-customer-growth-calculator-d818dc8d4a4b5a425af09b5ff370ac12.svg";